var map = {
	"./OtherProjects/3dBox.webp": 8062,
	"./OtherProjects/CoronaTracker.png": 5098,
	"./OtherProjects/CoronaTracker.webp": 9243,
	"./OtherProjects/DemoWebsite.png": 7343,
	"./OtherProjects/DemoWebsite.webp": 222,
	"./OtherProjects/HuffmanCoding.png": 4974,
	"./OtherProjects/HuffmanCoding.webp": 6754,
	"./OtherProjects/KMeanClusturing.png": 4690,
	"./OtherProjects/KMeanClusturing.webp": 7629,
	"./OtherProjects/QuineMcCluskyMinimization.png": 3308,
	"./OtherProjects/QuineMcCluskyMinimization.webp": 6883,
	"./OtherProjects/StopWatch.png": 3222,
	"./OtherProjects/StopWatch.webp": 1660,
	"./OtherProjects/WarshallAlgorithm.png": 5796,
	"./OtherProjects/WarshallAlgorithm.webp": 2462,
	"./OtherProjects/Wordle.png": 4558,
	"./OtherProjects/Wordle.webp": 7908,
	"./OtherProjects/adviceGenerator.png": 7067,
	"./OtherProjects/adviceGenerator.webp": 2271,
	"./OtherProjects/sobel_filter.png": 2620,
	"./OtherProjects/sobel_filter.webp": 1457
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1050;